import * as React from 'react';
import $ from 'jquery';
import { EmailControl } from './../sharedcomponents/EmailControl';

interface EmailState {
    EmailHtml: any;
}

export class SharedEmailPopUp extends React.Component<any, EmailState>{
    constructor(props: any) {
        super(props);  
        this.state = { EmailHtml: '' };
        this.renderEmailControl(this.props.gridData, this.props.colDefs, this.props.formName, this.props.parentChild);
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.gridData.length == 0) {
            $('#dashBoardEmailPopUp').hide();
        }
        else {
            $('#dashBoardEmailPopUp').show();
        }

        this.renderEmailControl(nextProps.gridData, nextProps.colDefs, nextProps.formName, nextProps.parentChild);
    }

    closeToolBarModel() {
        $('.GridToolBarParent').removeAttr('disabled');
        $('#dashBoardEmailPopUp').hide();
    }

    renderEmailControl(gridData: any, colDefs: any, formName: string, parentChild:string) {
        this.setState({ EmailHtml: this.returnEmailPopUp(gridData, colDefs, formName, parentChild) });
    }

    returnEmailPopUp(gridData: any, colDefs: any, formName: string, parentChild: string) {
        return <EmailControl reeferStatusResult={gridData} columnDefinition={colDefs} parentchild={parentChild} formname={formName} />;
    }

    componentDidMount() {
        if (this.props.gridData.length == 0) {
            $('#dashBoardEmailPopUp').hide();
        }
        else {
            $('#dashBoardEmailPopUp').show();     
        }           
    }

    public render() {
        return <div className="modal" role="dialog" id="dashBoardEmailPopUp">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Email</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.closeToolBarModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                        
                    </div>
                    <div className="modal-body">
                        {this.state.EmailHtml}
                    </div>
                </div>
            </div>
        </div>;
    }
} 